function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.7 18.6l-.4-.4c-1.1-1.1-1.1-2.8 0-3.9L5.7 10 1.3 5.7C.2 4.6.2 2.9 1.3 1.8l.4-.4C2.8.3 4.5.3 5.6 1.4L10 5.7l4.4-4.4c1.1-1.1 2.8-1.1 3.9 0l.4.4c1.1 1.1 1.1 2.8 0 3.9L14.3 10l4.4 4.4c1.1 1.1 1.1 2.8 0 3.9l-.4.4c-1.1 1.1-2.8 1.1-3.9 0L10 14.3l-4.3 4.3c-1.2 1.1-2.9 1.1-4 0z",
  fillRule: "nonzero",
  fill: "#231F20"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default SvgComponent;